<div fxLayout="column" fxLayoutGap="12px" [formGroup]="form"
     fxFlexfill
     *ngIf="localTaxRates && form && xeroTaxRates; else loadingMessage">
    <div fxLayout="column" fxLayoutGap="32px" fxFlex="0 1 auto" fxLayoutAlign="start stretch">
        <div fxLayout="row" *ngFor="let taxRate of localTaxRates" fxLayoutAlign="space-between center"
             fxLayoutGap="64px"
             [formGroupName]="taxRate.config_sequence.toString()">
            <p>HireLogic rate: <strong>{{taxRate.name}} - {{taxRate.value * 100}}%</strong></p>
            <p *ngIf="form.value[taxRate.config_sequence.toString()]['xero_tax_rate']; else noTaxRate">
                Xero Rate: <strong>{{form.value[taxRate.config_sequence.toString()]['xero_tax_rate'].name}}</strong>
            </p>
            <ng-template #noTaxRate>
                <p class="text-red-600">There is no corresponding tax rate in Xero.</p>
                <button mat-stroked-button (click)="createNewTaxRate(taxRate)">Create</button>
            </ng-template>
        </div>
    </div>
</div>
<ng-template #loadingMessage>
    <div fxLayout="row" fxFlex="0 0 400px" fxLayoutAlign="center center">
        <div fxFlex="0 0 600px" fxLayout="column" fxLayoutAlign="center center">
            <div fxFlex="row" fxLayoutAlign="center center">
                <p class="text-center" fxFlex="0 0 75">Fetching tax rates from Xero</p>
            </div>
            <mat-spinner [diameter]="50"></mat-spinner>
        </div>
    </div>
</ng-template>